import React, { useRef } from 'react';
import Highlighter from 'react-highlight-words';

const PayerPayeeSearch = (props) => {
  const {
    loading,
    handleSearchPayerPayee,
    togglePayerPayeeHoverEnter,
    activatePayerPayeeLookup,
    setPayerPayeeLookup,
    payerPayeeValue,
    payerPayeeData,
    payerPayeeIndex,
    setPayerPayeeValue,
    payerPayeeF7Type
  } = props;

  // Input ref for possible future focus management
  const inputRef = useRef(null);

  // Handler for input change (only allow letters, numbers, spaces)
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^[a-zA-Z0-9\s]*$/.test(value)) {
      setPayerPayeeValue(value);
    }
  };

  // Handler for Enter key
  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleSearchPayerPayee();
    }
  };

  // Handler for closing the search
  const handleClose = () => setPayerPayeeLookup(false);

  // Handler for clicking a payer row
  const handlePayerRowClick = () => {
    activatePayerPayeeLookup();
  };
  const fieldType = payerPayeeF7Type==="payee"?"Payee":"Payer"
  return (
    <div className="bg-color h-search">
      {/* Search Bar */}
      <div className="search-grid">
        <div className="py-2 row d-flex align-items-center">
          <div className="col-lg-1 text-end">
            <span className="fw-bolder text-white">Search {fieldType} :</span>
          </div>
          <div className="col-lg-10">
            <input
              ref={inputRef}
              type="search"
              placeholder={`Search ${fieldType} (at least 3 char)`}
              style={{ cursor: loading ? 'not-allowed' : 'text' }}
              onChange={handleInputChange}
              autoFocus
              onKeyDown={handleInputKeyDown}
              className="form-control b-r-10 ms-2 form-control-search"
              value={payerPayeeValue}
            />
          </div>
          <div className="col-lg-1">
            <button
              type="button"
              onClick={handleClose}
              className="btn text-white fw-bolder"
            >
              X
            </button>
          </div>
        </div>
      </div>

        <LookupTable
        type={payerPayeeF7Type}
        data={payerPayeeData}
        value={payerPayeeValue}
        loading={loading}
        activeIndex={payerPayeeIndex}
        onRowClick={handlePayerRowClick}
        onHoverEnter={togglePayerPayeeHoverEnter}
        />

    </div>
  );
};

export default PayerPayeeSearch;


const LookupTable = ({
  type, // "payer" or "payee"
  data,
  value,
  loading,
  activeIndex,
  onRowClick,
  onHoverEnter
}) => {
  const columns = type === "payee"
    ? ["Name", "NPI", "Tax ID", "Id Code Qualifier", "Address", "City", "Zip", "State"]
    : ["Name", "Payer Identification", "Id Code Qualifier", "Address", "City", "Zip", "State"];

  const fieldMap = type === "payee"
    ? ["name", "identification_code", "tax_identification_number", "id_code_qualifier", "address", "city", "zip", "state"]
    : ["name", "identification_code", "id_code_qualifier", "address", "city", "zip", "state"];

    return (
    <div style={{ marginTop: "80px" }}>
      {/* Table Header */}
      <ul className="list-group list-group-horizontal payer-ul-scroll">
        {columns.map((col, idx) => (
          <li key={idx} className="list-group-item item-width-full py-1 fs-7">{col}</li>
        ))}
      </ul>

      {/* Table Body */}
      {loading ? (
        <div className="text-center p-5">
          <span className="fw-bolder fs-4">Searching...</span>
        </div>
      ) : (
        <>
          {data && data.length > 0 ? (
            data.map((item, ind) => (
              <ul
                key={ind}
                onMouseEnter={() => onHoverEnter(ind)}
                onClick={() => onRowClick(item)}
                className={
                  activeIndex === ind
                    ? "list-group list-group-horizontal active-" + type
                    : "list-group list-group-horizontal"
                }
              >
                {fieldMap.map((field, idx) => (
                  <li key={idx} className="list-group-item option-item py-1 fs-7">
                    <Highlighter
                      highlightClassName="YourHighlightClass"
                      searchWords={[value]}
                      autoEscape
                      textToHighlight={item[field] || ""}
                    />
                  </li>
                ))}
              </ul>
            ))
          ) : (
            <div className="py-3 text-center">
              <span className="fw-bolder">No data</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};
